import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import LookupsHelper from 'lib/LookupsHelper';
import { PartTypes } from 'vdlib';

//const partTypes = null;

const partTypesData = {
  [PartTypes.New]: { title: I.t('PART_TYPE_NEW'), className: 'success' },
  [PartTypes.Used]: { title: I.t('PART_TYPE_USED'), className: 'danger' },
  [PartTypes.Imitation]: {
    title: I.t('PART_TYPE_IMITATION'),
    className: 'warning',
  },
};

const BidTypeCellRenderer = data => {
  let partType = LookupsHelper.getDescription('partTypes', data.PartTypeID);
  return (
    <span
      key="newbid"
      className={`label label-${partTypesData[partType].className}`}
    >
      {partTypesData[partType].title}
    </span>
  );
};

export default BidTypeCellRenderer;
